import React, { useEffect, useState } from "react";
import { AddContactIcon, SetProductivityRightMarkIcon } from "../common/Icon";
import { useStateProvider } from "../common/StateProvider";
import MyTeammates from "./MyTeammates";
import MyTeamFollowUp from "./MyTeamFollowUp";
import MyShecdule from "./MyShecdule";

const SetTodayProductivity = () => {
  // GET THE ACTIVE AND SETACTIVE TAB  FROM PROVIDER
  const { teamActiveTab, setTeamActiveTab } = useStateProvider();

  const currentDate = new Date();
  // Get current year, month, and date
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth() + 1;
  const date = currentDate.getDate();
  const fullDate =
    date.toString() + "-" + month.toString() + "-" + year.toString();

  return (
    <>
      <div className="mt-[35px] ">
        <div className=" flex  flex-col sm:flex-row items-center justify-between mx-[11px]">
          <div>
            <h5 className="text-sm font-bold text-black text-center sm:text-start 3xl:text-base">
              Set Todays productivity
            </h5>
            <div className=" flex items-center gap-2 pt-1">
              <p className="text-xs 3xl:text-sm font-normal text-center md:text-start text-black opacity-70">
                Selecting the team members and create productive task{" "}
              </p>
            </div>
          </div>
          <div className="pt-2">
            <button className="text-sm 3xl:text-base font-medium text-primary p-2.5 rounded-[36px] border border-solid border-primary flex items-center gap-2.5 hover:text-white bg-transparent hover:bg-primary transition-all duration-300 ease-in-out group">
              <span>
                <AddContactIcon />
              </span>
              Add team member
            </button>
          </div>
        </div>
        <div>
          <div className=" overflow-x-auto overflow_x_scroll_style mb-2 mx-[11px]">
            <div className=" flex gap-2 pt-5 w-max sm:w-auto pb-2">
              <button
                onClick={() => setTeamActiveTab("myteammates")}
                className={`text-xs 3xl:text-sm font-normal text-black opacity-70 p-[8px_10px] rounded bg-[rgba(111,_106,_248,_0.10)] hover:bg-primary hover:text-white hover:opacity-100 duration-300 ${
                  teamActiveTab === "myteammates"
                    ? " !bg-primary !text-white !opacity-100"
                    : ""
                } `}>
                My Teammates
              </button>

              <button
                onClick={() => setTeamActiveTab("followUps")}
                className={`text-xs 3xl:text-sm font-normal text-black opacity-70 p-[8px_10px] rounded bg-[rgba(111,_106,_248,_0.10)] hover:bg-primary hover:text-white hover:opacity-100 duration-300 ${
                  teamActiveTab === "followUps"
                    ? " !bg-primary !text-white !opacity-100"
                    : ""
                } `}>
                Follow Ups
              </button>
              <button
                onClick={() => setTeamActiveTab("meeting")}
                className={`text-xs 3xl:text-sm font-normal text-black opacity-70 p-[8px_10px] rounded bg-[rgba(111,_106,_248,_0.10)] hover:bg-primary hover:text-white hover:opacity-100 duration-300 ${
                  teamActiveTab === "meeting"
                    ? " !bg-primary !text-white !opacity-100"
                    : ""
                } `}>
                My Schedule
              </button>
            </div>
          </div>
          <div className=" xl:h-[calc(100vh-590px)] 3xl:h-[calc(100vh-620px)] xl:overflow-y-auto overflow-x-auto overflow_x_scroll_style pe-2 relative ">
            {teamActiveTab === "myteammates" && <MyTeammates />}
            {teamActiveTab === "followUps" && <MyTeamFollowUp />}
            {teamActiveTab === "meeting" && <MyShecdule />}
          </div>
          <div className=" fixed bottom-12 right-[5%] xl:right-[36%] 3xl:right-[37%] min-[2200px]:right-[39%] 3xl:bottom-16 z-10">
            <button className="text-xs  3xl:text-sm font-semibold text-white px-2  md:px-[14px] bg-primary rounded-[38px] right-icon border border-solid border-primary flex items-center py-2 md:py-3 hover:bg-white hover:text-primary duration-300">
              <span className="pr-1">
                <SetProductivityRightMarkIcon />
              </span>
              Set Productivity{" "}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default SetTodayProductivity;
